"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAdjustBodyHeight = void 0;
const react_1 = require("react");
const useAdjustBodyHeight = (isOpenModal, modalRef) => {
    (0, react_1.useEffect)(() => {
        const adjustBodyHeight = () => {
            var _a;
            if (isOpenModal) {
                if (modalRef === null || modalRef === void 0 ? void 0 : modalRef.current) {
                    const bodyHeight = document.body.getBoundingClientRect().height;
                    const modalHeight = (_a = modalRef.current) === null || _a === void 0 ? void 0 : _a.offsetHeight;
                    if (modalHeight > bodyHeight) {
                        document.body.style.height = `${modalHeight}px`;
                    }
                }
            }
            else if (document.body.style.height) {
                document.body.style.removeProperty('height');
            }
        };
        const timeoutId = setTimeout(adjustBodyHeight, 100);
        return () => clearTimeout(timeoutId);
    }, [isOpenModal]);
};
exports.useAdjustBodyHeight = useAdjustBodyHeight;
